// import getters from './getters'
// import mutations from './mutations'
// import actions from './actions'

export default {
  state: {
    statusList: [],
    leadStatusList: [],
    payStatusList: [],
    onFileSelect: undefined,
    settings: { public: {}, env: {} },
    options: [],
    optionsSettings: [],
    info: {},
    itemList: [],
    deliveryOptions: [],
    payments: [],
  },
  getters: {
    statusList: (state) => state.statusList,
    leadStatusList: (state) => state.leadStatusList,
    info: (state) => state.info,
    payStatusList: (state) => state.payStatusList,
    onFileSelect: (state) => state.onFileSelect,
    symbol: (state) => {
      if (state.settings) {
        if (state.settings.public.symbol) {
          return state.settings.public.symbol;
        } else if (state.settings.env.C_SYMBOL) {
          return state.settings.env.C_SYMBOL;
        }
      }
    },
    options: (state) => state.options,
    settings: (state) => state.settings,
    deliveryOptions: (state) => state.deliveryOptions,
    payments: (state) => state.payments,
    itemList: (state) => state.itemList,
  },
  mutations: {
    setInfo: (state, value) => (state.info = value),
    setStatusList: (state, value) => (state.statusList = value),
    setLeadStatusList: (state, value) => (state.leadStatusList = value),
    payStatusList: (state, value) => (state.payStatusList = value),
    onFileSelect: (state, callback) => (state.onFileSelect = callback),
    setOptions: (state, value) => {
      state.options = value.result;
      state.optionsSettings = value.settings;
    },
    setSettings: (state, value) => (state.settings = value),
    setDeliveryOptions: (state, value) => (state.deliveryOptions = value),
    setPayments: (state, value) => (state.payments = value),
    setItemList: (state, value) => (state.itemList = value),
  },
  // actions
};
